@if (staticOptions()) {
    <div [class]="colsCssClass()" [formGroup]="_form()">
        @if (dividedItems().length === 1) {
            @for (item of dividedItems()[0]; track item[valueKey()]) {
                <ng-container [ngTemplateOutlet]="itemGroup"
                    [ngTemplateOutletContext]="{ $implicit: item, group: _form() }"></ng-container>
            }
        } @else {
            @for (group of dividedItems(); track $index) {
                <div class="flex-column gap">
                    @for (item of group; track item[valueKey()]) {
                        <ng-container [ngTemplateOutlet]="itemGroup"
                            [ngTemplateOutletContext]="{ $implicit: item, group: _form() }"></ng-container>
                    }
                </div>
            }
        }
    </div>
}

<!-- --------------------------------- -->
<!-- ----------- TEMPLATES ----------- -->
<!-- --------------------------------- -->

<ng-template #itemGroup let-item let-group="group">
    <div class="flex gap-small" [formGroup]="group">
        <p-radioButton
            [inputId]="id() + '_' + item[valueKey()]"
            [formControlName]="id()"
            [value]="item[valueKey()]"
            [name]="name()"
        ></p-radioButton>
        <label [for]="id() + '_' + item[valueKey()]">
            @if (labelTemplate()) {
                <ng-container
                    *ngTemplateOutlet="labelTemplate(); context: { $implicit: item }"
                ></ng-container>
            } @else {
                {{ item[labelKey()] }}
            }
        </label>
    </div>
</ng-template>
